import type { MembershipAccountInfoProps } from './membership-account-info.component';

/**
 * Maps HTML attribute names (kebab-case) to Component prop names (camelCase)
 */
export const MEMBERSHIP_ACCOUNT_INFO_ATTRIBUTE_MAP: Record<
  string,
  keyof MembershipAccountInfoProps
> = {
  'membership-id': 'membershipId',
  'current-product-title': 'currentProductTitle',
  'current-product-title-size': 'currentProductTitleSize',
  'order-history-url': 'orderHistoryUrl',
  'show-login': 'showLogin',
  'max-width': 'maxWidth',
  'cancel-text': 'cancelText',
  'show-manage-button': 'showManageButton',
  'card-background-color': 'cardBackgroundColor',
  'card-text-color': 'cardTextColor',
  'card-button-color': 'cardButtonColor',
  'card-button-text-color': 'cardButtonTextColor',
  'column-border-color': 'columnBorderColor',
  'column-border-width': 'columnBorderWidth',
  'border-radius': 'borderRadius',
  'horizontal-padding': 'horizontalPadding',
  'vertical-padding': 'verticalPadding',
};

/**
 * Properties that should be converted from string to boolean
 */
const BOOLEAN_PROPS = new Set(['showLogin', 'showManageButton', 'maxWidth']);

/**
 * Converts a string attribute value to the appropriate type
 */
function convertAttributeValue(propName: string, value: string): any {
  if (BOOLEAN_PROPS.has(propName)) {
    // Convert string "true"/"false" to boolean
    return value === 'true';
  }
  return value;
}

/**
 * Extracts attributes from an HTMLElement and converts them to Component props
 */
export function extractMembershipAccountInfoAttributes(
  element: HTMLElement
): Partial<MembershipAccountInfoProps> {
  const props: Partial<MembershipAccountInfoProps> = {};
  for (const [attrName, propName] of Object.entries(MEMBERSHIP_ACCOUNT_INFO_ATTRIBUTE_MAP)) {
    const value = element.getAttribute(attrName);
    if (value !== null) {
      (props as any)[propName] = convertAttributeValue(propName, value);
    }
  }
  return props;
}
